import { StringUtils } from './string-utils';
import { FormGroup } from '@angular/forms';

export class FormUtils {
  public static formatPhoneNumber(input: string): string {
    let stripped = StringUtils.stripNonDigits(input);

    if (!stripped) {
      return stripped;
    }

    if (stripped.charAt(0) === '1') {
      stripped = stripped.substring(1);
    }

    let returnStr = '(' + FormUtils.getSubstringFromPhoneNumber(stripped, 0, 3);

    if (stripped.length < 4) {
      return returnStr;
    } else {
      returnStr = returnStr + ') ';
    }

    returnStr = returnStr + FormUtils.getSubstringFromPhoneNumber(stripped, 3, 3);

    if (stripped.length < 7) {
      return returnStr;
    } else {
      returnStr = returnStr + '-';
      const substr = FormUtils.getSubstringFromPhoneNumber(stripped, 6);
      return returnStr + substr;
    }
  }

  private static getSubstringFromPhoneNumber(
    stripped: string,
    start: number,
    targetSize?: number,
  ): string {
    if (stripped.length > start + (targetSize || 0)) {
      return stripped.substr(start, targetSize);
    }

    return stripped.substring(start);
  }

  public static resetAndClean(form: FormGroup): void {
    form.reset();

    Object.keys(form.controls)
      .map((fieldName) => form.controls[fieldName])
      .forEach((control) => {
        control.markAsPristine();
        control.markAsUntouched();
      });
  }
}
